import {
  Box,
  Flex,
  Spinner,
  Text,
  useColorModeValue,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
} from "@chakra-ui/react";
import UsageChart from "./UsageChart";


function StatsCard({ title, stat }) {
  return (
    <Stat
      px={{ base: 2, md: 4 }}
      py={3}
      borderRadius="lg"
      background={useColorModeValue("#F5F3F9", "#1e1530")}
      shadow="sm"
      h="100%"
    >
      <StatLabel fontWeight="bold" mb={2} fontSize={"16px"}>
        {title}
      </StatLabel>
      <StatNumber fontSize="12px" fontWeight="normal">
        {stat}
      </StatNumber>
    </Stat>
  );
}

export default function CampaignsUsage({ data, isLoading }) {
  const inputTextColor = useColorModeValue("#421e66", "#b5b5cd");

  if (isLoading) {
    return (
      <Flex align="center" gap={2}>
        <Spinner size="sm" />
        <Text>Loading...</Text>
      </Flex>
    );
  }

  if (!data) {
    return <Text fontSize="sm" color="gray.500">No campaign usage data found.</Text>;
  }

  const renderStats = (title, data) => {
    return (
      <StatsCard
        title={title}
        stat={
          <Flex fontSize="13px" color={inputTextColor} direction={'column'} gap={1}>
            <Text>
              Custom Range: {data?.customRange}
            </Text>
            <Text>
              Total Spend: {data?.totalSpend}
            </Text>
          </Flex>
        }
      />
    );
  };

  return (
    <Box mt={4}>
      <SimpleGrid
        columns={{ base: 1, md: 2, xl: 2 }}
        spacing={{ base: 5, lg: 8 }}
        w={{ base: "100%", lg: "50%" }}
      >
        {renderStats("Campaigns", data)}
      </SimpleGrid>

      {/* Chart for Campaign daily usage */}
      <Box mt={6}>
        <Text fontWeight="bold" mb={2} fontSize="16px">
          Campaign Daily Usage
        </Text>
        <UsageChart data={data.dailyUsage} />
      </Box>
    </Box>
  );
}
